import { render, staticRenderFns } from "./StavPredPujcenim.vue?vue&type=template&id=5239a03d&"
import script from "./StavPredPujcenim.vue?vue&type=script&lang=ts&"
export * from "./StavPredPujcenim.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports